/**
 * Overall status for one row of the sync log list.
 *
 * Partial rows count as errors here. They carry rejected fields even though nothing landed in
 * users_failed_sync, so leaving them out reported a sync with skipped fields as a clean green
 * "Completed" — and moved connect-workers rows that used to be counted as failures into the
 * clean bucket (PY-12481).
 */
/**
 * Employees the sync updated, counting the partial ones. A partial row applied some of its fields,
 * so leaving it out dropped the employee from every column in the list while the status chip still
 * reported an error — a sync of one partial row read as 0 updated and 0 failed (PY-12481). The
 * rejected half is reported by the chip here and itemized on the log's detail page.
 */
export const getUpdatedEmployeeCount = (log) => {
	const synced = log.users_successfully_synced;
	if (synced === undefined || synced === null) {
		return "";
	}
	return synced + (log.users_partially_synced || 0);
};

export const getLogStatusLabel = (log) => {
	if (log.is_processing) {
		return { label: "Processing", color: "default" };
	}

	const requiresApprovalToDeactivate = log.requires_approval_to_deactivate || [];
	if (
		!log.user_deactivation_approved &&
		!log.user_deactivation_dismissed &&
		requiresApprovalToDeactivate.length > 0
	) {
		return { label: "Pending Deactivation", color: "orange" };
	}

	if ((log.errors || []).length > 0) {
		return { label: "Failed", color: "red" };
	}

	if (log.users_failed_sync > 0 || log.users_partially_synced > 0) {
		return { label: "Completed with Errors", color: "yellow" };
	}

	return { label: "Completed", color: "green" };
};
